module.exports = __webpack_public_path__ + "static/fonts/iconfont.fcf18f27.ttf";